<script lang="ts">
    import { EasyVrpApp } from './EasyVrpApp';
    import type { Entry } from '../telematics/components/MultiSelectWide/types';
    import SwitchBar from '../../shared/SwitchBar/SwitchBar.svelte';
    import { SwitchBarApp } from '../../shared/SwitchBar/SwitchBarApp';
    import EasyVrpFormSettings from './EasyVrpFormSettings.svelte';
    import EasyVrpFormResults from './EasyVrpFormResults.svelte';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import Tabs from '../../shared/Tabs.svelte';
    import { get } from 'svelte/store';
    import { mapContext } from './EasyVrpMap/MapContext';
    import MenuContextEasyVrpDisplaySettings from './MenuContextEasyVrpDisplaySettings.svelte';

    export let app: EasyVrpApp;

    let switchBarApp: SwitchBarApp = new SwitchBarApp();

    switchBarApp.setItems([
        { id: 'settings', label: 'Ustawienia' },
        { id: 'results', label: 'Wyniki obliczeń' },
    ]);
    switchBarApp.selectItems(['settings']);
    switchBarApp = switchBarApp;

    let calculationInProgress: boolean = app.calculationInProgress();

    $: calculationInProgress = app.calculationInProgress();
</script>

<div style="overflow: hidden;">
    <div
        style="display: flex; align-items: center; justify-content: space-between; gap: 5px; flex-direction: row;  margin-bottom: 0; padding-bottom: 20px;"
    >
        <div>
            {#if switchBarApp.getSelectedItems()[0] === 'results'}
                <div style="display: flex; align-items: center; gap: 5px; flex-direction: row; ">
                    <MenuContextEasyVrpDisplaySettings
                        {app}
                        onChange={() => {
                            console.log('MenuContextEasyVrpDisplaySettings');
                            if (get(mapContext) !== null) {
                                app.getMapManager().reloadMapElements(get(mapContext));
                                app = app;
                            }
                        }}
                    />
                </div>
            {/if}
        </div>
        <div style="display: flex; justify-content: flex-end;">
            <div
                style="display: flex; align-items: center; gap: 5px; flex-direction: row; padding: 0 20px;"
            >
                {#if calculationInProgress}
                    <div style="display: flex; align-items: center; gap: 5px; flex-direction: row;">
                        <IconPending spin={true} scale={0.6} />
                        <span> Trwa obliczanie tras... </span>
                    </div>
                {/if}
            </div>
            <div style="width:260px;">
                <!--            <SwitchBar bind:switchBarApp />-->
                <Tabs
                    selectedId={switchBarApp.getSelectedItems()[0]}
                    items={switchBarApp.getItems()}
                    onChange={id => {
                        switchBarApp.selectItems([id]);
                        switchBarApp = switchBarApp;
                    }}
                />
            </div>
        </div>
    </div>
    <div style="overflow-y: auto; height: calc(100vh - 180px);">
        {#if switchBarApp.isItemSelected('settings')}
            <div style="display: flex; flex-direction: column; gap: 10px;">
                <EasyVrpFormSettings bind:app />
            </div>
        {:else if switchBarApp.isItemSelected('results')}
            <div style="display: flex; flex-direction: column; gap: 10px;">
                <EasyVrpFormResults bind:app />
            </div>
        {/if}
    </div>
</div>
